import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Modal,
  WrapperFlex,
  Text,
  ScrollBar,
} from '@unimed-fesp/components';

import DropDownSearchBox from '../DropDownSearchBox';
import TableContratantes from '../TableContratantes';
import TableUsariosEspelho from '../TableUsariosEspelho';

import { TipoConsultaParametrizacaoEnum } from '../../../enums';

function ModalConsultaContratantes({
  isOpen,
  onClick,
  params,
  setParams,
  grupoComplementosParams,
  contratanteParams,
  rowsChecked,
  setRowsChecked,
  paginationParams,
  setPaginationParams,
  handleSearchTable,
  setTipoBusca,
  handleAdicionarModal,
  handleCheckUser,
  selectedUser,
}) {
  const dispatch = useDispatch();

  function handleChangePage(paramsPgs) {
    dispatch(setTipoBusca(params.tipoParametrizacao, paramsPgs));
  }

  function handlePageChangeKeyDown(e) {
    if (e.keyCode === 13) {
      dispatch(setTipoBusca(params.tipoParametrizacao));
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClick={(e) => onClick(e)}
      width={916}
      height={544}
      top={43}
      justifyContentFooter="flex-end"
      header={<>consultar</>}
      footer={
        <ModalFooter
          onClick={onClick}
          handleAdicionarModal={() => handleAdicionarModal()}
        />
      }
    >
      <WrapperFlex flex="1" padding={20} maxHeight={400} paddingTop={1}>
        <WrapperFlex column>
          <WrapperFlex marginTop={10} column justifySpaceBetween>
            <DropDownSearchBox
              dropdownName="tipoParametrizacao"
              inputName="buscaParametrizacao"
              onBlur={handleSearchTable}
              params={params}
              setParams={setParams}
              options={TipoConsultaParametrizacaoEnum.returnName}
              inputWidth="600"
              placeholder={
                TipoConsultaParametrizacaoEnum.returnPlaceHolderForName[
                  params.tipoParametrizacao
                ]
              }
              handleInputKeyDown={handleSearchTable}
              onClick={(e) => handleSearchTable(e, true)}
            />
          </WrapperFlex>
          <WrapperFlex marginTop={25} column>
            <Text text="resultados de consulta" type="headlineOne" bold />
            <ScrollBar colorScroll="#5A5A5A" height={280}>
              {params.tipoParametrizacao ===
              TipoConsultaParametrizacaoEnum.returnName[3] ? (
                <TableUsariosEspelho
                  selectedUser={selectedUser}
                  handleCheckUser={handleCheckUser}
                  paginationParams={paginationParams}
                  handleChangePage={handleChangePage}
                  setPaginationParams={setPaginationParams}
                  handlePageChangeKeyDown={handlePageChangeKeyDown}
                />
              ) : (
                <TableContratantes
                  grupoComplementosParams={grupoComplementosParams}
                  contratanteParams={contratanteParams}
                  setPaginationParams={setPaginationParams}
                  paginationParams={paginationParams}
                  handlePageChangeKeyDown={handlePageChangeKeyDown}
                  initialParams={params}
                  rowsChecked={rowsChecked}
                  setRowsChecked={setRowsChecked}
                  handleChangePage={handleChangePage}
                />
              )}
            </ScrollBar>
          </WrapperFlex>
        </WrapperFlex>
      </WrapperFlex>
    </Modal>
  );
}

const ModalFooter = ({ onClick, handleAdicionarModal }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={(e) => onClick(e)}
        justifyCenter
        alignCenter
        type="button"
        marginRight={10}
        font="16px unimed_slabregular"
        width={100}
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        justifyCenter
        alignCenter
        type="button"
        onClick={(e) => {
          handleAdicionarModal();
          onClick(e);
        }}
        font="16px unimed_slabregular"
        width={100}
      >
        adicionar
      </Button>
    </>
  );
};

export default ModalConsultaContratantes;
